import React, { Component } from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import LabelSelect from '../../common/label/selection.component.jsx'
import SubSectionEditForm from './subsection.component.jsx'
import Icon from "../../common/icon/icon.component.jsx"
const uuidv4 = require('uuid/v4')

class SectionEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.section = this.props.section
        this.state = {
            sectionName: this.section.attributes.name,
            sectionDescription: this.section.attributes.description,
            labelIds: this.section.attributes.labelIds,
            subSections: this.section.attributes.subSections,
        }
        this.nextOrder = this.state.subSections.length.toString()
        this.handleNameChange = this.handleNameChange.bind(this)
        this.handleLabelIdsChange = this.handleLabelIdsChange.bind(this)
        this.deleteSection = this.deleteSection.bind(this)
        this.onSubSectionChange = this.onSubSectionChange.bind(this)
        this.onSubSectionDelete = this.onSubSectionDelete.bind(this)
        this.createNewSubSection = this.createNewSubSection.bind(this)
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this)

        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback
        this.onDelete = this.props.onDelete || defaultCallback
    }

    handleNameChange(event) {
        this.setState({
            sectionName: event.target.value
        }, () => {
            this.sectionChange()
        })
    }

    handleDescriptionChange(event) {
        this.setState({
            sectionDescription: event.target.value
        }, () => {
            this.sectionChange()
        })
    }

    handleLabelIdsChange(labelIds) {
        this.setState({
            labelIds: labelIds
        }, () => {
            this.sectionChange()
        })
    }

    deleteSection() {
        event.preventDefault()
        this.onDelete(this.section)
    }

    onSubSectionChange(subSection) {
        this.setState({
            subSections: this.state.subSections.map(s => {
                if (s.id === subSection.id) {
                    return subSection
                } else {
                    return s
                }
            })
        }, () => {
            this.sectionChange()
        })
    }

    sectionChange() {
        this.section.attributes.subSections = this.state.subSections
        this.section.attributes.name = this.state.sectionName
        this.section.attributes.labelIds = this.state.labelIds
        this.section.attributes.description = this.state.sectionDescription
        this.onChange(this.section)
    }

    onSubSectionDelete(subSection) {
        this.setState({
            subSections: this.state.subSections.filter(s => s.id !== subSection.id)
        }, () => {
            this.sectionChange()
        })
    }

    createNewSubSection(event) {
        event.preventDefault()
        this.section.attributes.subSections.push({
            id: uuidv4(),
            attributes: {
                parentSectionId: this.section.id,
                name: '',
                order: this.nextOrder,
                labelIds: [],
            },
        })
        this.nextOrder = this.state.subSections.length.toString()
        this.setState({
            subSections: this.section.attributes.subSections
        }, () => {
            this.onChange(this.section)
        })
    }

    render() {
        let labels = <div className="col-6">
            <LabelSelect
                name={'labelIds-' + this.section.id}
                value={this.state.labelIds}
                onChange={this.handleLabelIdsChange}
                multi={true}
            />
            <small className="form-text text-muted">
                <FormattedMessage
                    id="guided_selling.form.edit.section_label_ids_description"
                    defaultMessage="Select labels that will filter the section search"
                />
            </small>
        </div>
        let nameSize = 'col-4'
        if (this.state.subSections.length > 0) {
            nameSize = 'col-10'
            labels = ''
        }

        return <div>
            <div className="form-group row" >
                <div className={nameSize}>
                    <input
                        name={'name-' + this.section.id}
                        value={this.state.sectionName}
                        onChange={this.handleNameChange}
                        type="text"
                        className="form-control"
                        placeholder={this.props.intl.formatMessage({
                            id: 'guided_selling.form.edit.section_name_placeholder',
                            defaultMessage: 'Name of the section',
                        })}
                    />
                    <small className="form-text text-muted">
                        <FormattedMessage
                            id="guided_selling.form.edit.section_name_description"
                            defaultMessage="The name will show on each quote using this model"
                        />
                    </small>
                </div>
                {labels}
                <div className="col-2 text-align-right">
                    <button className="btn btn-primary btn-sm" onClick={this.createNewSubSection}>
                        <Icon value={"folder-plus"}/>
                    </button>
                    &nbsp;
                    <button className="btn btn-danger btn-sm" onClick={this.deleteSection}>
                        <Icon value={"trash"}/>
                    </button>
                </div>
                <div className="col-12">
                    <input
                        name={'description-' + this.section.id}
                        value={this.state.sectionDescription}
                        onChange={this.handleDescriptionChange}
                        type="text"
                        className="form-control"
                        placeholder={this.props.intl.formatMessage({
                            id: 'guided_selling.form.edit.section_description_placeholder',
                            defaultMessage: 'Description of the section',
                        })}
                    />
                    <small className="form-text text-muted">
                        <FormattedMessage
                            id="guided_selling.form.edit.section_description_description"
                            defaultMessage="The description will show on each quote using this model"
                        />
                    </small>
                </div>
            </div>
            {this.state.subSections.map(
                subSection => <SubSectionEditForm
                    key={subSection.id}
                    subSection={subSection}
                    onChange={this.onSubSectionChange}
                    onDelete={this.onSubSectionDelete}
                />
            )}
        </div>
    }


}

export default injectIntl(SectionEditForm)


// WEBPACK FOOTER //
// ./src/guided-selling/form/section.component.jsx